export default {
  SET_SUCURSAL(state, sucursal) {
    state.sucursalSeleccionada = sucursal
  },
  CLEAR_SUCURSAL(state) {
    state.sucursalSeleccionada = null
  },
}